import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.format();
  }

  format() {
    const docxElements = this.element.querySelectorAll('[data-docx]');
    console.log('docx', docxElements);

    docxElements.forEach((element) => {
      const tag = element.tagName.toLowerCase();

      let attrs = null;
      try {
        attrs = JSON.parse(element.getAttribute('data-docx') || 'null');
      } catch (e) {
        return;
      }

      if (!attrs) {
        return;
      }

      switch (tag) {
        case 'p':
          return this.formatParagraph(element, attrs);

        case 'span':
          return this.formatSpan(element, attrs);

        case 'td':
          return this.formatTd(element, attrs);
      }
    });
  }

  formatParagraph(/** @type {Element} */ element, /** @type {object} */ attrs) {
    // "start" | "center" | "end" | "both" | "mediumKashida" | "distribute" | "numTab" | "highKashida" | "lowKashida" | "thaiDistribute" | "left" | "right"
    switch (attrs.alignment) {
      case 'start':
      case 'left':
        element.classList.add('text-left');
        break;

      case 'center':
        element.classList.add('text-center');
        break;

      case 'end':
      case 'right':
        element.classList.add('text-right');
        break;

      case 'distribute':
        element.classList.add('text-justify');
        break;
    }
  }

  formatSpan(/** @type {Element} */ element, /** @type {object} */ attrs) {
    if (attrs.bold) {
      element.classList.add('font-bold');
    }
    if (attrs.italics) {
      element.classList.add('italic');
    }
    if (attrs.underline) {
      element.classList.add('underline');
    }
    if (attrs.strike) {
      element.classList.add('line-through');
    }
    if (typeof attrs.highlight === 'string') {
      const styles = this.prepareStyleAttr(element);
      styles.push(`background-color:${attrs.highlight}`);
      this.setStyleAttr(element, styles);
    }
  }

  formatTd(/** @type {Element} */ element, /** @type {object} */ attrs) {
    const styles = this.prepareStyleAttr(element);

    if (typeof attrs.width === 'number') {
      styles.push(`width:${Math.round(attrs.width * 3.7795)}px`);
    }

    if (typeof attrs.borders === 'object') {
      ['top', 'right', 'bottom', 'left'].forEach((side) => {
        const border = attrs.borders[side];
        if (!border) {
          return;
        }

        const tailwindSide = `border-${side.substring(0, 1)}-`;

        element.classList.add(`${tailwindSide}${this.borderStyle(border.style)}`);
        if (typeof border.size === 'number') {
          styles.push(`border-${side}-width:${border.size}px`);
        }
      });
    }

    this.setStyleAttr(element, styles);
  }

  borderStyle(docxBorderStyle) {
    if (!docxBorderStyle) {
      return 'none';
    }

    switch (docxBorderStyle) {
      case 'none':
      case 'nil':
        return 'none';

      case 'dashed':
      case 'dashSmallGap':
        return 'dashed';

      case 'dotted':
      case 'dotDash':
      case 'dotDotDash':
        return 'dotted';

      case 'double':
        return 'double';

      // case 'single':
      default:
        return 'solid';
    }
  }

  prepareStyleAttr(/** @type {Element} */ element) {
    const existingStyles = element.getAttribute('style');
    if (existingStyles) {
      return [existingStyles];
    }
    return [];
  }

  setStyleAttr(/** @type {Element} */ element, /** @type {string[]} */ styles) {
    if (!styles?.length) {
      return;
    }
    element.setAttribute('style', styles.join(';'));
  }
}
